import React from 'react';
import getBugsnagClient from './getBugsnagClient';
import getIsInFederalEnvironment from '@lifeomic/phc-web-toolkit/src/util/getIsInFedEnvironment';

const isInFederalEnvironment = getIsInFederalEnvironment();

const RootErrorBoundary = ({
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  children,
}) => {
  if (process.env.DISABLE_BUGSNAG_REPORTING || isInFederalEnvironment)
    return <React.Fragment>{children}</React.Fragment>;
  try {
    const apiKey = (window as any).__INITIAL_STATE__.config.bugsnagKey;
    const releaseStage = (window as any).__INITIAL_STATE__.config.releaseStage;
    const beforeSend = (report: any) => {
      report.breadcrumbs = report.breadcrumbs.map((b: any) => {
        if (
          (b.metaData || {}).targetText &&
          (b.metaData || {}).targetText !== '(...)'
        ) {
          b.metaData.targetText = '[REDACTED]';
        }
        return b;
      });
    };
    const client = getBugsnagClient({ apiKey, releaseStage, beforeSend });
    const BugsnagBoundary = client.getPlugin('react');
    return <BugsnagBoundary>{children}</BugsnagBoundary>;
  } catch (e) {
    console.warn('Error boundary not loaded');
    return <React.Fragment>{children}</React.Fragment>;
  }
};

export default RootErrorBoundary;
